import { useCallback, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { EMAIL_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutV2/CheckoutForm";
import { usePunditUserContext } from "@circle-react/contexts";
import { CheckoutFormField } from "../../CheckoutFormField";

export const CheckoutFormEmailField = () => {
  const {
    trigger,
    formState: { errors },
    watch,
  } = useFormContext();
  const { currentCommunitySettings } = usePunditUserContext();
  const isMailgunValidationEnabled =
    currentCommunitySettings?.mailgun_validation_during_checkout_enabled;

  const emailValue = watch("email");

  const handleBlur = useCallback(async () => {
    if (isMailgunValidationEnabled) {
      await trigger("email");
    }
  }, [trigger, isMailgunValidationEnabled]);

  useEffect(() => {
    const validateEmail = async () => {
      if (isMailgunValidationEnabled && errors.email) {
        await trigger("email");
      }
    };

    void validateEmail();
  }, [emailValue, trigger, isMailgunValidationEnabled]);

  return (
    <CheckoutForm.Item name="email">
      <CheckoutFormField
        type="text"
        name="email"
        onBlur={handleBlur}
        options={{
          required: true,
          pattern: EMAIL_REGEX,
        }}
      />
    </CheckoutForm.Item>
  );
};
